export default "__VITE_ASSET__B0H31yFG__"